var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Heading as RebassHeading } from 'rebass';
export default function Heading(_a) {
    var sx = _a.sx, inheritColor = _a.inheritColor, _b = _a.variant, variant = _b === void 0 ? 'h3' : _b, loading = _a.loading, props = __rest(_a, ["sx", "inheritColor", "variant", "loading"]);
    return (React.createElement(RebassHeading, __assign({ as: variant, variant: "heading." + variant }, props, { sx: __assign(__assign(__assign({ fontFamily: 'Lato', fontWeight: 1, letterSpacing: 0, lineHeight: 'normal', m: 0, color: 'neutral_8' }, (sx ? sx : {})), (inheritColor ? { color: 'inherit !important' } : {})), (loading ? { letterSpacing: '0px', color: 'neutral_2 !important' } : {})) })));
}
